export type Brand = 'empresarial-prime' | 'prime-conecta';

export interface BrandProfile {
  id: string;
  role: string;
  roles?: string[];
  funcao?: string | null;
  equipe_id?: string | null;
  ativo: boolean;
}

export function canChooseBrand(profile: BrandProfile | null | undefined): boolean {
  if (!profile?.ativo) return false;
  return profile.funcao === 'RH_DEPARTAMENTO_PESSOAL' ||
    [profile.role, ...(profile.roles ?? [])].some(role =>
      ['master', 'diretor', 'gerente', 'supervisor', 'coordenador', 'bko', 'qualidade'].includes(role));
}

export function isBrand(value: unknown): value is Brand {
  return value === 'empresarial-prime' || value === 'prime-conecta';
}

export function resolveBrand(tipoPessoa: string | null | undefined, canChoose: boolean, preference: unknown): Brand {
  if (canChoose && isBrand(preference)) return preference;
  return tipoPessoa === 'PF' ? 'prime-conecta' : 'empresarial-prime';
}

export function brandPreferenceKey(profile: BrandProfile, tipoPessoa: string | null | undefined): string {
  return `crm-brand:${profile.id}:${profile.equipe_id ?? 'sem-equipe'}:${tipoPessoa ?? 'sem-segmento'}`;
}
